// extracted by mini-css-extract-plugin
export default {"container":"logo_container__Aa9t9","logo":"logo_logo__Q3fCN","title":"logo_title__F6HU0"};